import React from "react";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";
import MatchTypeComponent from "./MatchTypeComponent";

function FileToSpecView(props) {
  return (
    <div>
      <LabelWithInputDisabled label="Test Suite" value={props.testSuite} />
      <MatchTypeComponent
        matchType={props.matchType}
        fileName={props.fileName}
      />
    </div>
  );
}

export default FileToSpecView;
